import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    async submit() {
        this.element.querySelectorAll('input').forEach((el) => {
            el.setAttribute('readonly', 'readonly');
        });

        const response = await fetch(location.href, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: new FormData(this.element.closest('form')),
        });

        const el = document.createElement('div');
        el.innerHTML = (await response.text());
        el.querySelectorAll('.error').forEach((el) => {
            el.remove();
        });
        this.element.replaceWith(...el.childNodes);
    }
}
